<template>
  <ion-button
    :disabled="!allowAttach"
    class="btn-not-request mr-0"
    color="primary"
    expand="block"
    @click="requestQuotation"
  >
    <span class="ml-1">{{ $t('request_quotation') }}</span>
  </ion-button>

  <ion-loading
    :is-open="isOpenLoadingref"
    cssClass="custom-loading"
    message=""
    spinner="crescent"
    @didDismiss="setOpenLoading(false)"
  >
  </ion-loading>
</template>
<script>
import { NOTIFICATION_TYPE } from '@/modules/b2b/constants';
import { ACTIONS as ACTIONS_PRODUCT } from '@/modules/b2b/store/product/actions';
import { IonButton, IonLoading } from '@ionic/vue';
import { ref } from 'vue';
import { useStore } from 'vuex';

export default {
  components: {
    IonButton,
    IonLoading
  },

  props: {
    selectedCompanyId: {
      type: Number,
      required: true,
      default: 0
    },
    tenantId: {
      type: Number,
      required: true,
      default: 0
    },
    userId: {
      type: Number,
      required: true,
      default: 0
    },
    skuId: {
      type: Number,
      required: true,
      default: 0
    },
    customer: {
      type: String,
      required: true,
      default: ''
    },
    allowAttach: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  emits: ['update-local-request-quotation'],

  setup(props, { emit }) {
    const store = useStore();
    const isOpenLoadingref = ref(false);
    const setOpenLoading = (state) => (isOpenLoadingref.value = state);
    // Actions
    const requestQuotationAction = async (params) =>
      await store.dispatch('b2b/product/' + ACTIONS_PRODUCT.REQUEST_QUOTATION, params);

    const requestQuotation = async () => {
      setOpenLoading(true);
      await requestQuotationAction({
        payload: {
          userId: props.userId,
          customerBuyerId: props.selectedCompanyId,
          skuId: props.skuId,
          tenantId: props.tenantId,
          targetOnly: true,
          notificationType: NOTIFICATION_TYPE.NEW_QUOTATION,
          customer: props.customer
        }
      });
      setOpenLoading(false);
      emit('update-local-request-quotation');
    };
    return {
      NOTIFICATION_TYPE,
      isOpenLoadingref,
      setOpenLoading,
      requestQuotationAction,
      requestQuotation
    };
  }
};
</script>
<style lang="scss" scoped>
.btn-not-request {
  margin: 0.5rem;
  height: 45px;
  --border-radius: 10px;
  text-transform: none;
  font-size: 16px;
  line-height: 19px;
}
</style>
